import { FaFacebookF, FaLinkedin, FaPinterest, FaYoutube } from "react-icons/fa";


export const socialLinks = [
  { name: "Facebook", icon: <FaFacebookF />, url: "https://www.facebook.com/profile.php?id=61561026695570" },
  { name: "Pinterest", icon: <FaPinterest />, url: "https://www.pinterest.com/as_designs834/" },
  { name: "YouTube", icon: <FaYoutube />, url: "https://www.youtube.com/channel/UCgssM6yU0Z943KCP_4RJ5Yg" },
  { name: "LinkedIn", icon: <FaLinkedin />, url: "https://www.linkedin.com/company/as-designs986/" }
];